import React from 'react'
import Helmet from 'react-helmet'
import { config } from 'config'
import _ from 'lodash'
import { Container, Grid, Breakpoint, Span } from 'react-responsive-grid'
import { rhythm } from 'utils/typography'
import PortfolioHead from 'components/PortfolioHead'
import PortfolioNextPrevLink from 'components/PortfolioNextPrevLink'
import PortfolioIntroBanner from 'components/PortfolioIntroBanner'
import works from 'data/works'
import { findWork } from 'data/works-helper'
import Gallery from 'components/Gallery'

export default class ReactComponent extends React.Component {

  prefixPath(fileName) {
    return this.props.route.page.path + fileName;
  }

  render () {
    this.galleries = [
      [
        {src: this.prefixPath('landing.jpg'), caption: 'Landing Page'},
        {src: this.prefixPath('mockup-02.jpg'), caption: 'Modules directory'},
        {src: this.prefixPath('mockup-03.jpg'), caption: 'Module details'},
        {src: this.prefixPath('mockup-04.jpg'), caption: 'Modules directory (mobile)'},
        {src: this.prefixPath('mockup-05.jpg'), caption: 'Modules directory (mobile)'},
        {src: this.prefixPath('mockup-06.jpg'), caption: 'Modules detail (mobile)'}
      ]
    ];

    this.galleries[0] = this.galleries[0].map((v, i) => {
      v.index = i;
      return v;
    });

    const data = findWork(works, this.props.route.page.path);
    return (
      <div>
        <Helmet
          title={`${config.siteTitle} | ${data.name}`} 
        />
        <PortfolioHead data={data} />
        <Container
            style={{
              maxWidth: 960,
              paddingTop: 0,
              padding: `${rhythm(1)} ${rhythm(3/4)}`,
            }}
          >
          
          <PortfolioNextPrevLink data={data} />
          <div className="section">
            <div className="section-header">
              <h2>Intro</h2>
            </div>
            <p>
              Angie is a beauty guru LINE chatbot that we have developed in LINE’s private Hackathon for an undisclosed brand (which will be referred to as Brand X on this page). Our team was given a task from Brand X to acquire more users for their line of hair conditioner products using LINE Business Connect API. 
            </p>
            <br />
            <p>
              According to research, although most Thai people use shampoo everyday, hair conditioners are often viewed as unnecessary goods that should be used only on special occasions. Because of this, Brand X aims to increase the use of their hair conditioner and acquire its new customers, especially from the demographic group of female aged between 17 - 24.
            </p>

            <br />
            
          </div>

          <div className="section">
            <p>
              Our team proposed a 3-phase plan to engage hair conditioner customers.
            </p>
            <br />
            
            <h3>1-on-1 User Acquisition</h3>
            <p>
              LINE official accounts are usually used for one-way communication from the brands. 
              This results in most of the accounts being eventually blocked or ignored. 
              To enable a deeper user engagement, we introduced Angie, a beauty guru chatbot that could answer customer’s hair treatment questions as well as other topics of interest to our target group.
            </p>
            
            <br />

            <p>
              In order to achieve this in the demo, our developers have implement a semi-automatic answering system based on ElasticSearch (ES). The chatbot would look for similar questions already asked by other users using ES's full-text search. This allows some level of tolerance to nonstandard spellings. If no such questions exist, the chatbot could wait for manual response from a content administrator and pass the response back to the user. As the designer, I have also provided illustrations for Angie's identity and detailed hair treatment infographic.  
            </p>
            <br/>

            <p>
              I have also provided illustrations for Angie's identity and detailed hair treatment tips answered to the user.
            </p>
            <img src={this.prefixPath('brand-x-line-hack-01.jpg')} />
            <br /><br />
            
            <h3>Large scale user acquisition</h3>
            <p>
              LINE official accounts do not possess the ability to virally advertise themselves like other media such as Facebook Pages. For this, we have proposed a plan to acquire multiple users at a time by using Song Challenge, a game where each player has to name a song after the last alphabet of the song named by the previous player. In our version, the whole chat group members are invited to play against the chatbot for a small reward, e.g. LINE mission stickers. With this approach, our chatbot could engage users one conversation group at a time.  
            </p>
            <br />
            <p>
              In the demo, we used ElasticSearch with a small song database to implement Song Challenge. The user input is parsed for song validation and to extract the first alphabet which is then used for searching the chatbot's next song.
            </p>
            <br />
            

            <br />
            <img src={this.prefixPath('brand-x-line-hack-02.jpg')} />
            <br />
            <br />
            <h3>Activation</h3>
            <p>
              The most challenging part of acquiring a user is usually to convert them into a paying customer. In phase 3, We proposed a lucky draw campaign in which the user needs to buy and take a photo of the product to participate. The campaign holds an advantage over usual lucky draw that the official account can auto user’s LINE id for future engagements.
            </p>
            <br/ >
            <img src={this.prefixPath('brand-x-line-hack-03.jpg')} />
          </div>
          <br />
          
          <br />
          <div className="section">
            <div className="section-header">
              <h2>Contributors</h2>
            </div>
            <ul>
              <li>Komthep Saksriyuttana (Developer)</li>
              <li>Natthakit Susanthitanon (Developer)</li>
              <li>Soravis Prakkamakul (UX/UI Designer)</li>
              <li>Sarawoot Piya-arayanunt (Developer)</li>
            </ul>
          </div>
          <PortfolioNextPrevLink data={data} />
          <br />
          <br />

        </Container>
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./works/brand-x-line-hack/index.jsx
 **/